import styled from 'styled-components';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from '../../constants';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';

export const ListTitleTextCasino777Box = styled(ListTitleTextDefaultBox)`
    text-transform: capitalize;
    padding: 0.6rem 2rem 0.6rem 4.5rem;
    font-size:2rem;
    border-left: none;

    z-index:0;
    clipPath: polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0);
    ${CssRule.For.RTL.build()} & {
      clipPath: polygon(0 0, 0 100%, 100% 100%, calc(100% - 10px) 50%, 100% 0);
    }
  
    letter-spacing: 0.1rem;

    &:before {
        content: "";
        position: absolute;
        background-image: url("${({theme}) => theme.assets.images.SpriteSheetPC1920_png.toString()}");
        height: 20px;
        width: 20px;
        top: 10px;
        left: 16px;
        background-position: -176px -766px;
        background-repeat: no-repeat;
        z-index:-1;
        ${CssRule.For.RTL.build()} & {
          transform: scaleX(-1);
        }
    }

    .${JACKPOT_WIDGET} & {
        border-left: none;
    }

    .${RED_TIGER_JACKPOT} & {
        border-left: none;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      padding: 1rem 5.5rem;
      font-size:2rem;
    }


    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        align-items: flex-start;
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: .5rem 4rem;
        font-size: 1.6rem;
        &:before{
          background-position: -176px -819px;
        }
    }
  
  
    
`;
